import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5a657755"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sync-with-gws-view-container" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "text-row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-row" }, " Google Workspaceで管理者権限を持つユーザーだけが実行できます。 ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-row spaced" }, " 実行するには、以下のボタンをクリックしてください。 ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SyncWithGWSButton = _resolveComponent("SyncWithGWSButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, " Google Workspace上のすべての" + _toDisplayString(_ctx.userTypeJapanese) + "を、まなポートに取り込みます。 ", 1),
      _hoisted_4,
      _hoisted_5
    ]),
    _createVNode(_component_SyncWithGWSButton, {
      class: "button",
      enabled: !_ctx.syncing,
      "on-click": _ctx.syncWithGWS
    }, null, 8, ["enabled", "on-click"])
  ]))
}